<template>
  <!-- <van-uploader :after-read="onRead" > -->
  <div class="uploader-content">
    <div class="upload-item delete-icon" v-bind:key="index" v-for="(image,index) in imagePreviews">
      <van-icon name="close" @click="deleteImage(index)"/>
      <img :src="image" class="image-preview" @click="previewImage(image)">
    </div>
    <div class="upload-item uploader-btn"  v-if="!single || (single && imagePreviews.length < 1)">
      <van-uploader
        :after-read="onRead"
        :accept="accept"
        :before-read="preRead"
        class="sby-uploader"
        v-bind:class="{border: withBorder}"
        v-on:oversize="onOversize"
        :result-type="resultType"
        :max-size="maxSize * 1024"
        :disabled="disabled"
       
      >
        <div>
          <van-icon name="plus" class="add-file-icon" />
          <p v-if="withTip">{{tip}}</p>
        </div>
      </van-uploader>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
const { readImage, fileAsBlob, asBlob } = require("../assets/mobile-image.js");
const IMAGE_EXTS = [".jpg", ".jpeg", ".gif", ".png"];

import { Icon, Toast, Uploader, ImagePreview } from "vant";

export default {
  name: "sby-uploader",
  props: {
    disabled: Boolean,
    beforeRead: Function,
    afterRead: Function,
    preview: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: "image/*"
    },
    resultType: {
      type: String,
      default: "dataUrl"
    },
    maxSize: {
      //给KB
      type: Number,
      default: 5120 //默认是5M
    },
    // 是否压缩, 默认是true
    compress: {
      type: Boolean,
      default: true
    },
    imageOnly: {
      type: Boolean,
      default: true
    },
    tip: {
      type: String,
      default: ""
    },
    /**
     * 是否带边框
     */
    withBorder: {
      type: Boolean,
      default: true
    },
    /**
     * 是否允许显示提示
     */
    withTip: {
      type: Boolean,
      default: true
    },
    /**
     * 预加载的图片预览数据
     */
    previewData: {
      type: String,
      default: ""
    },
    /**
     * 是否自动上传到服务器去，默认是true，兼容低端机内存太小的问题
     */
    autoUpload: {
      type: Boolean,
      default: true
    },

    single: {
      type: Boolean,
      default: true
    }
  },
  components: {
    [Uploader.name]: Uploader
  },
  data() {
    return {
      imagePreviews: [],
      //当前远程资源的链接
      currentImageLinks: []
    };
  },
  mounted: function() {
    // if (this.preview && !_.isEmpty(this.previewData)) {
    //   this.imagePreview = [this.previewData];

    //   let ret = { content: this.previewData };
    //   this.afterRead && this.afterRead(ret);
    // }
  },
  watch: {
    // 修复组件已经初始化，数据延迟加载的问题
    // previewData(val) {
    //   this.imagePreview = val;
    // }
  },
  computed: {
    previewable() {
      return this.preview && !_.isEmpty(this.imagePreviews);
    }
  },
  methods: {
    onOversize(result) {
      // console.log("图片尺寸过大");
      Toast(
        "你选择的图片太大,我们目前的尺寸最多接受" +
          (this.maxSize / 1024).toFixed(2) +
          "M"
      );
    },
    previewImage: function(image) {
      ImagePreview([image]);
    },

    preRead(file) {
      console.log("read: file: ", file);
      if (this.imagePreviews.length >= 3) {
        Toast("最多只支持上传三张图片");
        return false;
      }
      if (this.imageOnly) {
        //格式忽略,直接检查图片.
        let ext = file.name.substr(file.name.lastIndexOf(".")).toLowerCase();
        if (!IMAGE_EXTS.includes(ext)) {
          Toast("只支持图片,请选择有效的图片文件");
          return false;
        }
      }

      return true;
    },
    /**
     * result 有 file对象 & content(可以直接img 引用的base64图片)
     */
    onRead(result) {
      console.log("读取文件", result);
      if (this.compress) {
        console.log(
          "文件选择后",
          result,
          "图片大小是: ",
          result.content.length
        );

        readImage({
          blob: asBlob(result.file),

          success: image => {
            console.log("压缩后图片大小", image.length);
            console.log(this.imagePreviews, "this.imagePreviews");
            if (this.preview) {
              this.imagePreviews.push(image);
            }
            let ret = { file: result.file, content: image };
            this.afterRead && this.afterRead(ret);

            this.$emit("onRead", ret);
            this.upload(ret);
          }
        });
      } else {
        if (this.preview) {
          this.imagePreviews.push(result.content);
        }
        this.afterRead && this.afterRead(result);
        this.$emit("onRead", result);
        this.upload(result);
      }
    },
    deleteImage(index) {
      let lastLink = this.currentImageLinks[index];
      if (!lastLink) {
        return;
      }
      //删除之前的
      this.$http
        .post("/api/common/remove", { path: lastLink })
        .then(removeRes => {
          if (removeRes) {
            console.log("删除上次的图片成功", lastLink);

            this.$hideLoading();
            this.imagePreviews.splice(index, 1);
            this.currentImageLinks.splice(index, 1);

            if (this.single) {
                  this.$emit("upload", '');
                } else {
                  this.$emit("upload", this.currentImageLinks);
                }
          }
        });
    },

    /**
     * 上传到服务器中去
     * 1. 上传到服务器去，阻塞流程
     * 2. 如果上次链接不为空，删除服务器地址，隐藏Loading
     * 3. 抛出upload结束的事件，返回 服务器地址
     */
    upload(result) {
      if (this.autoUpload) {
        if (!_.isEmpty(result.content)) {
          this.$showLoading();

          this.$http
            .post("/api/common/saveImage", { image: result.content })
            .then(response => {
              if (response) {
                this.imagePreviews.push(response.data.data.web);
                //let lastLink = this.currentImageLink;
                this.currentImageLinks.push(response.data.data.web); //保存当前服务器地址

                //if (!_.isEmpty(lastLink)) {

                //    } else {
                this.$hideLoading();

                if (this.single) {
                  this.$emit("upload", this.currentImageLinks[0]);
                } else {
                  this.$emit("upload", this.currentImageLinks);
                }
                console.log(this.currentImageLinks, "this.currentImageLinks");
                console.log(this.imagePreviews, response.data.data.web, "this.imagePreviews");
                //       }
              }
            });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.uploader-content {
  margin-bottom: 5px;
  .upload-item {
    float: left;
    height: 40px;
    width: 40px;
    border: 1px solid #9e9e9e;
    margin-left: 15px;
    margin-top: 5px;
  }
  .delete-icon {
    position: relative;
    .van-icon {
      position: absolute;
      top: -6px;
      z-index: 2;
      right: -7px;
    }
  }
  .image-preview {
    width: 100%;
    height: 100%;
    text-align: center;
  }

  .uploader-btn {
    border: 1px solid #9e9e9e;
    float: left;
    vertical-align: middle;
    text-align: center;
    font-size: 16px;

    .van-icon {
      margin-top: 36%;
    }
  }
  .sby-uploader {
    display: block;
    width: 100%;
    height: 100%;

    &.border {
      border: 1px #f2f2f2 solid;
    }

    .add-file-icon {
      margin-top: 1px;
      color: #0ba3d2;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/sby-uploader.vue